<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      @change="handleChange"
      :multiple="multiple"
      filterable
      :disabled="disabled"
      :size="size"
      :placeholder="placeholderBackup"
      :collapse-tags="collapse"
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.store_name"
        :value="item.id"
        :disabled="disabledIds.includes(item.id)"
      />
    </el-select>
  </div>
</template>

<script>
import { index } from '@/api/store';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    clearable: Boolean,
    multiple: Boolean,
    collapse: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    isLocationLimit: Boolean,
    disabled: Boolean,
    hasPrivate: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    valueBackup: '',
    placeholderBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({
        is_all: 1,
        is_location_limit: this.isLocationLimit ? 1 : 0,
        has_private: this.hasPrivate ? 1 : 0,
      });
      if (isError) return;

      this.list = data;
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
    this.placeholderBackup = this.placeholder || '';
    this.getList();
  },
};
</script>
